import {showToast} from "../../toast";
import {Api} from "../../api/api";
import {ActionUrl, GROUP_CLASS_NAME, RENAME_GROUP_CLASS_NAME} from "../constants";
import {KeyboardKeys} from "../../utils/consts";

/**
 * Функционал для изменения имени группы меток. В конструктор передаются сам элемент, которому не обходимо поменять названеие.
 */
class RenameGroup {
  #element;
  #currentName;
  #id;

  #api = new Api();
  #url = ActionUrl.RENAME_GROUP_URL;

  constructor() {
    this.onDocumentClick = this.onDocumentClick.bind(this);

    document.addEventListener(`click`, this.onDocumentClick);
  }

  #init() {
    this.#currentName = this.#element.textContent;
    this.#id = this.#element.closest(`.${GROUP_CLASS_NAME}`).dataset.id;

    this.onElementBlur = this.onElementBlur.bind(this);
    this.onElementKeydown = this.onElementKeydown.bind(this);

    if (this.#element.dataset.isFocused !== `true`) {
      this.#element.addEventListener(`blur`, this.onElementBlur);
      this.#element.addEventListener(`keydown`, this.onElementKeydown);
    }

    this.#element.dataset.isFocused = `true`;
  }

  /**
   * Отправка запроса на переименование элемента
   *
   * @returns {Promise<void>}
   */
  async #renameElement() {
    const {code, answer} = await this.#api.customQuery(`${this.#url}?id=${this.#id}&name=${this.#element.textContent.trim()}`, {});

    if (code === 200) {
      this.#currentName = this.#element.textContent.trim();
    } else {
      this.#element.textContent = this.#currentName;
      showToast(answer.text);
    }
  }

  /**
   * Удаление слушателей с элемента
   */
  #removeListeners() {
    this.#element.removeEventListener(`blur`, this.onElementBlur);
    this.#element.removeEventListener(`keydown`, this.onElementKeydown);
  }

  /**
   * Слушатель на клавишу enter
   *
   * @param event
   */
  onElementKeydown(event) {
    if (event.code === KeyboardKeys.ENTER) {
      this.#element.blur();
    }
  }

  /**
   * Слушатель на событие event
   */
  onElementBlur() {
    if (this.#element.textContent.trim().length !== 0 && this.#element.textContent !== this.#currentName) {
      void this.#renameElement();
    } else {
      this.#element.textContent = this.#currentName;
    }

    this.#removeListeners();
    this.#element.dataset.isFocused = `false`;
  }

  onDocumentClick({target}) {
    if (target.classList.contains(RENAME_GROUP_CLASS_NAME)) {
      this.#element = target;

      this.#init();
    }
  }
}

export {RenameGroup};
